import { Question } from "../../types";

export const isSjtQuestion = (question?: Question): boolean => {
  if (!question) return false;
  const typeIsSjt = question.type?.toLowerCase?.() === "sjt";
  const hasCorrectRank =
    Array.isArray(question.answerOptions) &&
    question.answerOptions.some((a) => typeof a.correctRank === "number");
  return typeIsSjt || hasCorrectRank;
};

export const getSjtCorrectOrderIds = (
  question: Question,
): number[] | undefined => {
  // Derive from correctRank on each answer option (1-based)
  if (
    Array.isArray(question.answerOptions) &&
    question.answerOptions.length > 0
  ) {
    const withRank = question.answerOptions.filter(
      (a) => typeof a.correctRank === "number",
    );
    if (withRank.length > 0) {
      return [...withRank]
        .sort((a, b) => (a.correctRank as number) - (b.correctRank as number))
        .map((a) => a.id);
    }
  }
  return undefined;
};

export const computeSjtCorrect = (
  question: Question,
  selection: number[] | undefined,
): boolean => {
  const correctOrder = getSjtCorrectOrderIds(question);
  const studentOrder = selection;
  if (!correctOrder || !studentOrder) return false;
  if (correctOrder.length !== studentOrder.length) return false;
  for (let i = 0; i < correctOrder.length; i++) {
    if (correctOrder[i] !== studentOrder[i]) return false;
  }
  return true;
};

export const getSjtSelectedOrderIds = (question: Question): number[] => {
  const options = question.answerOptions || [];
  // Prefer selectedOrder or selectedRank if present; also support legacy selectedOrderPosition
  const withAnyOrder = options
    .map((a) => {
      const selectedOrder = (a as any).selectedOrder;
      const selectedRank = (a as any).selectedRank;
      const legacyPos = (a as any).selectedOrderPosition;
      const orderValue =
        typeof selectedOrder === "number"
          ? selectedOrder
          : typeof selectedRank === "number"
          ? selectedRank
          : typeof legacyPos === "number"
          ? legacyPos
          : undefined;
      return orderValue !== undefined ? { id: a.id, order: orderValue } : null;
    })
    .filter((x): x is { id: number; order: number } => !!x);
  if (withAnyOrder.length === 0) return [];
  return withAnyOrder.sort((a, b) => a.order - b.order).map((x) => x.id);
};
